<template>
  <div class="menu-wrapper">
    <div class="menu-title">
      <div class="text">管理</div>
      <div class="line"></div>
    </div>
    <div class="title-line"></div>
    <!-- background-color="rgba(255,255,255,0)" -->
    <el-menu
      :default-active="path"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      active-text-color="#333"
    >
      <template v-for="(route,key) in Menus">
        <!-- 首先判断是否有下级菜单，并且是否不为空，并且是允许显示二级的 -->
        <subMenu
          :route="route"
          :key="key"
          v-if="route.children && route.children.length > 0 && !route.hiddeChilden"
        />
        <!-- 否则就直接渲染一级 -->
        <template v-else>
          <el-menu-item
            :index="route.meta.module"
            :key="key"
            @click="menuTab(route)"
            v-if="!route.hidden"
          >
            <!-- <i v-if="route.meta.iconClass && route.meta.iconClass !== ''" :class="route.meta.iconClass"></i> -->
            <span slot="title">{{$t(route.meta.title)}}</span>
            <i v-if="path == route.meta.module" class="el-icon-arrow-right right-arrow"></i>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
import routerMenus from "@/router";
import subMenu from "./submenu";
import { mapMutations, mapActions } from "vuex";
import { getMenus } from "@/utils/auth";
export default {
  name: "menuComment",
  components: {
    subMenu,
  },
  computed: {
    Menus() {
      return getMenus() ? getMenus() : [];
    },
    path() {
      return this.$route.meta.module;
    },
    isMobile() {
      return this.$store.state.app.isMobileMode;
    },
  },
  created() {},
  methods: {
    ...mapMutations({
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar",
    }),
    ...mapActions({
      logout: "user/logout",
      clearRoute: "navigation/clearRoutes",
    }),
    menuTab(route) {
      if (this.isMobile) {
        this.CloseMobileSideBar();
        this.CloseToolBar();
      }
      try {
        this.$router.push({ path: route.path });
      } catch (error) {}
    },
    handelLogout() {
      this.logout().then((res) => {
        if (res) {
          this.$router.push({ path: "/login" });
        }
      });
    },
    handleOpen() {},
    handleClose() {},
  },
};
</script>

<style lang="scss" scoped>
.menu-wrapper {
  box-sizing: border-box;
  width: 265px;
  min-height: 438px;
  // height: 100%;
  padding: 0 32px;
  padding-top: 47px;
  padding-bottom: 60px;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  background: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  ::v-deep {
    .el-menu {
      border-right: none;
      background: none;
    }
    .el-menu-item {
      height: 60px;
      line-height: 60px;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .el-submenu__title {
      padding: 0 !important;
      &:hover {
        color: #c9c9c9 !important;
        background-color: transparent;
      }
    }
    .el-menu-item-group {
      padding-left: 20px;
    }
    .el-menu-item.is-active {
      color: #c9c9c9 !important;
      background-color: transparent;
    }
    .el-menu-item:focus {
      background-color: transparent;
    }
  }
  .menu-title {
    box-sizing: border-box;
    overflow: hidden;
    .text {
      font-size: 15px;
      font-weight: bold;
      text-align: left;
    }
    .line {
      width: 100%;
      height: 3px;
      background-color: #333;
      margin-top: 12px;
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.menu-wrapper {
  .el-menu-item {
    .right-arrow {
      position: absolute;
      top: 22px;
      right: 0;
      font-size: 14px;
      margin-right: 0;
      visibility: hidden;
    }
  }

  .el-menu-item:hover {
    background: none;
    color: #c9c9c9 !important;
  }

  .el-menu-item.is-active {
    color: #c9c9c9 !important;
    .right-arrow {
      visibility: visible;
    }
  }
  .el-submenu__title,
  .el-menu-item {
    position: relative;
  }
}
</style>


